const initialState = {
    suggestedItemsList: []
};

export const suggestedItemsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_SUGGESTED_ITEMS":
            return {
                suggestedItemsList: action.payload
            }
        case "RESET_SUGGESTED_ITEMS":
            return initialState;
        default:
            return state;
    }
}